import * as React from "react";

const SvgIcnDirectoryBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M17.031 4c.417 0 .771.146 1.063.438.291.291.437.645.437 1.062v13c0 .417-.146.77-.437 1.063A1.447 1.447 0 0117.03 20H7.047c-.188 0-.404-.062-.649-.188-.244-.125-.367-.395-.367-.812v-2.016h-.515a.463.463 0 01-.336-.148.48.48 0 01-.149-.352c0-.135.05-.25.149-.343A.476.476 0 015.516 16h.515v-2h-.515a.463.463 0 01-.336-.148.48.48 0 01-.149-.352c0-.135.05-.25.149-.344a.476.476 0 01.336-.14h.515v-2.032h-.5a.468.468 0 01-.343-.14.468.468 0 01-.141-.344c0-.135.047-.25.14-.344a.468.468 0 01.344-.14h.5V8h-.547a.468.468 0 01-.343-.14A.468.468 0 015 7.515c0-.136.047-.253.14-.352a.455.455 0 01.344-.148h.547V5.03c0-.25.084-.484.25-.703.167-.219.427-.328.782-.328h9.968zm.5 14.5v-13a.48.48 0 00-.148-.352A.48.48 0 0017.03 5h-1v14h1a.48.48 0 00.352-.148.48.48 0 00.148-.352z"
            fill="currentColor"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        />
    </svg>
);

export default SvgIcnDirectoryBold;
